// extracted by mini-css-extract-plugin
export default {"select_treatment":"SelectTreatment_select_treatment__wvw7I","treatment_item":"SelectTreatment_treatment_item__D+nOK"};